// Full-page mail composer. Reached by navigating to /mail/compose (the screen
// switches to a dedicated write page instead of a floating modal). Reply/forward/
// draft data is passed via router location state.

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../../shared/api/client";
import { Loading } from "../../shared/components/Empty";
import { MailCompose } from "./MailCompose";
import type { MailDetail, Signature } from "./types";
import "./mail.css";

type ComposeState = {
  initial?: Partial<MailDetail> & { in_reply_to_id?: number; draftId?: number };
  draftId?: number;
};

export default function MailComposePage() {
  const nav = useNavigate();
  const loc = useLocation();
  const state = (loc.state || {}) as ComposeState;
  const [signature, setSignature] = useState<Signature | null>(null);
  const [ready, setReady] = useState(false);

  // Load signature before mounting the composer so its auto-attach effect sees it.
  useEffect(() => {
    void api.get<Signature>("/mail/signature/")
      .then((r) => setSignature(r.data))
      .catch(() => {})
      .finally(() => setReady(true));
  }, []);

  const back = () => {
    if (window.history.length > 1) nav(-1);
    else nav("/mail");
  };
  const done = () => {
    window.dispatchEvent(new Event("mail:refresh"));
    // 발송을 마치면 전체 메일함으로 이동한다(운영 요청).
    nav("/mail?filter=RECEIVED");
  };

  if (!ready) return <div style={{ padding: 40 }}><Loading /></div>;

  return (
    <div className="mail-compose-page">
      <MailCompose
        asPage
        open
        initial={state.initial}
        draftId={state.initial?.draftId ?? state.draftId}
        signature={signature}
        onClose={back}
        onSent={done}
      />
    </div>
  );
}
